import { createPluginFactory } from '@udecode/plate';

export const KEY_DOCUMENT_SETTINGS = 'document-settings';

export const createDocumentSettingsPlugin = createPluginFactory({
  key: KEY_DOCUMENT_SETTINGS,
  options: {
    documentSettings: {},
  },
});
